import { accountSetMeReducer } from '@slices/account/account-set-me';

import { appCreateSlice } from '@store/rtk';

import { AccountState } from './types';

export const accountDefaultState: AccountState = {
  me: {
    email: undefined,
    name: undefined,
  },
};

export const accountSlice = appCreateSlice({
  name: 'account',
  initialState: accountDefaultState,
  reducers: {
    accountSetMe: accountSetMeReducer,
  },
});

export const {
  actions: { accountSetMe },
  reducer: accountReducer,
} = accountSlice;
